import { MapPin, Clock, Target } from 'lucide-react';

export default function TodaySummaryCard({ visits }) {
  const today = new Date().toISOString().split('T')[0];
  const todayVisits = visits.filter(v => (v.visit_date || '').startsWith(today));

  const completed = todayVisits.filter(v => v.status === 'completed').length;
  const planned = todayVisits.filter(v => v.status === 'planned').length;
  const remaining = todayVisits.filter(v => ['planned', 'active'].includes(v.status)).length;
  const total = todayVisits.length;
  const achievePct = total > 0 ? Math.round((completed / total) * 100) : 0;

  const productive = todayVisits.filter(v => v.outcome === 'order' || v.outcome === 'collection').length;
  const strikeRate = completed > 0 ? Math.round((productive / completed) * 100) : 0;

  const durations = todayVisits.filter(v => v.duration_minutes > 0).map(v => v.duration_minutes);
  const avgDuration = durations.length > 0 ? Math.round(durations.reduce((a, b) => a + b, 0) / durations.length) : 0;

  const lastVisit = todayVisits.filter(v => v.status === 'completed').sort((a, b) => new Date(b.check_out_time || b.visit_date) - new Date(a.check_out_time || a.visit_date))[0];
  const lastVisitMins = lastVisit ? Math.round((Date.now() - new Date(lastVisit.check_out_time || lastVisit.visit_date)) / 60000) : null;

  return (
    <div className="bg-gradient-to-br from-primary to-primary/80 rounded-2xl p-4 text-white shadow-lg">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-bold text-white/90 text-sm">زيارات اليوم</h3>
        {achievePct > 0 && (
          <div className="bg-white/20 rounded-full px-2.5 py-0.5">
            <span className="text-xs font-bold">{achievePct}% مكتمل</span>
          </div>
        )}
      </div>

      <div className="grid grid-cols-4 gap-2 mb-3">
        {[
          { val: total || planned, label: 'مخطط' },
          { val: completed, label: 'تمت' },
          { val: remaining, label: 'باقي' },
          { val: achievePct + '%', label: 'إنجاز' },
        ].map((s, i) => (
          <div key={i} className="bg-white/15 rounded-xl p-2 text-center">
            <p className="text-xl font-black">{s.val}</p>
            <p className="text-xs text-white/70">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="space-y-1.5 text-xs text-white/80">
        {lastVisit && lastVisitMins !== null && (
          <div className="flex items-center gap-1.5">
            <MapPin className="w-3.5 h-3.5 flex-shrink-0" />
            <span>آخر زيارة: {lastVisit.customer_name} — منذ {lastVisitMins} دقيقة</span>
          </div>
        )}
        {avgDuration > 0 && (
          <div className="flex items-center gap-1.5">
            <Clock className="w-3.5 h-3.5 flex-shrink-0" />
            <span>متوسط الزيارة: {avgDuration} دقيقة</span>
          </div>
        )}
        {completed > 0 && (
          <div className="flex items-center gap-1.5">
            <Target className="w-3.5 h-3.5 flex-shrink-0" />
            <span>معدل النجاح: {strikeRate}%</span>
          </div>
        )}
      </div>
    </div>
  );
}